/**
 * One call from the page, drawn in two places: the hero, and the floating
 * panel the pill opens into once the hero has scrolled away. Both render from
 * this one state, so End call is never out of reach and the two can never
 * disagree about what the call is doing.
 */

/** `limit` is the visitor out of demo calls for the day: the button is dead. */
export type Phase = "ready" | "connecting" | "live" | "limit";

/** What she is doing, on a live call. */
export type Mode = "talking" | "listening";

export type Speaker = "her" | "you";

export type Turn = { who: Speaker; text: string };

export type NoteKey = "warn" | "end" | "limit" | "blocked" | "nomic" | "failed";

export type CallState = {
  phase: Phase;
  mode: Mode;
  turns: Turn[];
  note: NoteKey | null;
};

export const INITIAL: CallState = {
  phase: "ready",
  mode: "listening",
  turns: [],
  note: null,
};

/** Seconds a demo call may run, and when "30 seconds left" shows. */
export const LIMIT_SECS = 180;
export const WARN_SECS = 150;
